import { Divider, Grid, Typography } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SiNoChip } from "src/pages/sistema/components/FieldView";
import { OperacionADLFields } from "../types/fields";

type SeccionADLDetalleTransaccionProps = {
  operacion?: any;
}

const SeccionADLDetalleTransaccion = ({ operacion }: SeccionADLDetalleTransaccionProps) => {
  if (!operacion) return null;

  const tieneGarantias = operacion[OperacionADLFields.Garantias] === true;
  const esPrecancelable = operacion[OperacionADLFields.Precancelable] === true;

  return (
    <CardActions title='Detalle de la Transacción' icon='mdi:swap-horizontal' colapsable>
      <Grid container spacing={2.5} rowSpacing={2.5}>

        <Grid item xs={12} >
          <FieldView label='Entidad Puente acreedora' value={operacion[OperacionADLFields.EntidadPuenteAcreedora]} />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Moneda' value={operacion[OperacionADLFields.Moneda]} />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Monto' value={operacion[OperacionADLFields.Monto]} />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Comisión estructuración' value={operacion[OperacionADLFields.ComisionEstructuracion]} />
        </Grid>

        <Grid item xs={12} >
          <FieldView label='Tasa de interés' value={operacion[OperacionADLFields.TasaInteres]} />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Plazo' value={operacion[OperacionADLFields.Plazo]} />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Tipo de amortización de capital' value={operacion[OperacionADLFields.TipoAmortizacionCapital]} />
        </Grid>
        <Grid item xs={12} >
          <FieldView label='Frecuencia de pago de interes' value={operacion[OperacionADLFields.FrecuenciaPagoInteres]} />
        </Grid>

        <Grid item xs={12}>
          <Divider textAlign='left'>
            <Typography variant='caption' color='text.secondary' sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Garantías
            </Typography>
          </Divider>
        </Grid>

        <Grid item xs={4} >
          <FieldView label='Garantías'>
            <SiNoChip value={operacion[OperacionADLFields.Garantias]} />
          </FieldView>
        </Grid>

        {tieneGarantias && (
          <>
            <Grid item xs={12} >
              <FieldView label='Detalle garantías' value={operacion[OperacionADLFields.DetalleGarantias]} />
            </Grid>
            <Grid item xs={12} >
              <FieldView label='Detalle aforo' value={operacion[OperacionADLFields.DetalleAforo]} />
            </Grid>
          </>
        )}

        <Grid item xs={12}>
          <Divider textAlign='left'>
            <Typography variant='caption' color='text.secondary' sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Precancelación
            </Typography>
          </Divider>
        </Grid>

        <Grid item container xs={12}>
          <Grid item xs={4} >
            <FieldView label='Precancelable'>
              <SiNoChip value={operacion[OperacionADLFields.Precancelable]} />
            </FieldView>
          </Grid>
        </Grid>


        {esPrecancelable && (
          <Grid item xs={4} >
            <FieldView label='Condiciones de precancelación'>
              <SiNoChip value={operacion[OperacionADLFields.CondicionesPrecancelacion]} />
            </FieldView>
          </Grid>
        )}

      </Grid>
    </CardActions>
  );
};

export default SeccionADLDetalleTransaccion;